import React, { useState, useEffect, useContext,useCallback, Fragment } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import Layout from 'components/sales/layout/layout';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import TableSection from 'components/sales/tableSection/tableSection';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import {Button} from "react-bootstrap";

const ClientListingAll = ({
  getProjectOnboardingListing,
  projectOnboradingListing = [],
  fetchZones,
  filterDropdownList = null,
  getFetchZones = null,
  getClientList,
  clientListing
}) => {
  const [isFiled, setIsFiled] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState();
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);

  const Headers = [
    'Client Name',
    'PAN Number',
    'POC Name',
    'POC Email',
    'Action',
  ];
  console.log('PAGE::CLIENT-LIST-ALL');

  useEffect( () => {
    (async () => {
      setIsLoading(true)
      const roles = await JSON.parse(localStorage.getItem('roles'));
      roles && setIsRoleId(roles[0].pivot.role_id);
      await getClientList(null, 1)
      setIsLoading(false)
    })()
  }, [getClientList])
  //console.log('data ' + JSON.stringify(clientListing?.data?.length));
  //console.log('data2 ' + projectOnboradingListing?.resultSets.data);

  useEffect( () => {
    (async () => {
      setIsLoading(true)
      const roles = await JSON.parse(localStorage.getItem('roles'));
      roles && setIsRoleId(roles[0].pivot.role_id);
      await getProjectOnboardingListing(null, 1)
      setIsLoading(false)
    })()
  }, [])

  useEffect(() => {
    const tableData = [
      'id',
      'client_name',
      'pan_number',
      'poc_name',
      'poc_email',
    ];
    // const actions = [
    //   //{ name: 'View Details', link: `${baseUrl}/view-details` },
    //   {name : 'Add Address', link: `${baseUrl}/add-location/1`} //1 append for client address
    // ];
    setListData()
    if (clientListing && clientListing?.data?.length > 0 ) {
      const data = clientListing?.data?.map((element) =>
          Object.assign(
              {},
              ...tableData.map((key) => (
                  {
                   [key]: element[key],
                  })

              ),{Action: [
                  {name : 'Add Address', link: `${baseUrl}/add-client-location-all/1/${element['lead_id']}`},
                  {name : 'View Address', link: `${baseUrl}/view-client-address`} 
                  ]
                }
          )
      );
      data && setListData(data);
      setPageCount(Math.ceil(clientListing?.total / clientListing?.per_page));
    }
  }, [clientListing]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getClientList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
            onClick={filterToggle}
            className="filter-hamburger filter-btn btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
        
    </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getClientList(filter, val.selected + 1);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.clientList}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      //isGoback
      isLoading={isLoading}
      //linkUrl={`${baseUrl}/finance-business-list`}
    >
      <TableSection
          data={listData}
          headers={Headers}
          pageCount={pageCount}
          srNo={clientListing?.from}
          onPageChange={onPageChange}
          isId={false}
          detailList={clientListing && clientListing?.data}
      />
      <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          listFilterData={filterDropdownList && filterDropdownList.data}
          isRoleId={isRoleId}
          filterClientList
          clientFilter={true}
      />
    </Layout>
  );
};

ClientListingAll.propTypes = {};

export default ClientListingAll;
